<div ngClass.xs="mobile">
  <mat-sidenav-container class="sidenav-container">
    <mat-sidenav fixedInViewport="true" position="start" [(opened)]="sidenavLeftStatus"
                 (openedStart)="sidenavLeftOpened()" (closedStart)="sidenavLeftClosed()">
      <app-sidenav></app-sidenav>
    </mat-sidenav>
    <mat-sidenav fixedInViewport="true" class="padding8" position="end" [(opened)]="sidenavRightStatus"
                 (openedStart)="sidenavRightOpened()" (closedStart)="sidenavRightClosed()">
      <ng-template #sidenavTarget></ng-template>
    </mat-sidenav>
    <mat-sidenav-content>
      <app-toolbar class="mat-elevation-z4">
        <ng-template #toolbarTarget></ng-template>
      </app-toolbar>
      <app-offline *ngIf="connectionStatus === 4 || connectionStatus === 3"></app-offline>
      <div class="router-container">
        <router-outlet></router-outlet>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>